export interface StorageList {
    id?: number;
    user_by?: number;
    storage_name?: string;
    status?: 1 | 0;
}

// to single object maping
export const mapStorageList = (data:any): StorageList => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: StorageList ={
        id: data.id,
        user_by: data.user_by,
        storage_name: data.storage_name,
        status: data.status,
    }
    return res;
}

// maping list objects
export const mapStorageLists = (data:any[]): StorageList[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapStorageList);
}